import * as QuestionTypes from '../constants/questionTypes';

import { Question } from './question';

class AnswerElement {
  constructor({index, value, correct, ...rest}) {
    this.index = index;
    this.value = value;
    this.correct = correct;

    Object.assign(this, {...rest});
  }
}

const setAnswerElement = Symbol('setAnswerElement');
const setSingleAnswer = Symbol('setSingleAnswer');
const setMultiAnswer = Symbol('setMultiAnswer');

class Answer {
  constructor({uuid, question, sessionUuid, json, answerElements = [], ...rest}) {
    this.uuid = uuid;
    // if (!question) throw new Error('question cannot be null in Answer costructor!');
    this.question = new Question(question); /* type: Question */
    this.sessionUuid = sessionUuid;
    this.answerElements = answerElements.map(e => new AnswerElement(e)); /* type: [AnswerElement] */
    //override answerElements from json
    if (json)
      this.answerElements = JSON.parse(json);

    Object.assign(this, {...rest});
  }

  setAnswer(e) {
    switch(this.question.type) {
      case QuestionTypes.MULTI:
        this[setMultiAnswer](e);
        break;
      case QuestionTypes.COMBO:
        this[setAnswerElement](e);
        break;
      case QuestionTypes.SINGLE:
        this[setSingleAnswer](e);
        break;
      case QuestionTypes.DND:
        this[setAnswerElement](e);
        break;
      case QuestionTypes.FILL:
        this[setAnswerElement](e);
        break;
      default:
        /* do nothing */
        break;
    }
  };

  [setAnswerElement](answer) {
    const idx = this.answerElements.findIndex(el => el.index === answer.index);
    if (idx === -1)
       this.answerElements.push(answer);
    else
      this.answerElements[idx] = answer;
  }

  [setSingleAnswer](answer) {
    this.answerElements = [answer];
  }

  [setMultiAnswer](options) {
    this.answerElements = options;
  }

  toAnswerInput() {
    return {
      uuid: this.uuid,
      sessionUuid: this.sessionUuid,
      questionUuid: this.question.uuid,
      json: JSON.stringify(this.answerElements),
      isCorrect: this.answerElements.every(e => e.correct),
    };
  }
}

export { Answer, AnswerElement };
